import { Outlet } from 'react-router-dom';
import { Toaster } from '../../components/ui/sonner';

/**
 * BoscoCaptureLayout — wraps the mobile-first /bosco-capture/* route tree.
 *
 * The BOSCO Capture flow deliberately renders outside MainLayout (no top nav,
 * no side chrome — the mobile camera + kit picker need the full viewport).
 * That means the Sonner <Toaster/> mounted inside MainLayout isn't available,
 * so `toast.error(...)` / `toast.success(...)` calls from these screens are
 * silently dropped. We mount our own Toaster here so every /bosco-capture/*
 * screen gets working notifications with a single subscription instance.
 */
export default function BoscoCaptureLayout() {
  return (
    <>
      <Outlet />
      <Toaster position="top-center" richColors />
    </>
  );
}
